import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { updateConfirmationPayloadItem } from '@cashier/cashier-data-access';
import { ValidationStatuses } from '@cashier/cashier-model';

interface UseFileUploadField {
  onFileAttached: (reference: string) => void;
  onFileDetached: (reference: string) => void;
}

export const useFileUploadingField = (): UseFileUploadField => {
  const dispatch = useDispatch();

  const onFileAttached = useCallback(
    (reference: string): void => {
      dispatch(
        updateConfirmationPayloadItem({
          name: reference,
          fieldPayload: {
            value: null,
            validationStatus: ValidationStatuses.SUCCESS,
            interactionCompleted: true,
            errors: [],
          },
        }),
      );
    },
    [dispatch],
  );

  const onFileDetached = useCallback(
    (reference: string): void => {
      dispatch(
        updateConfirmationPayloadItem({
          name: reference,
          fieldPayload: {
            value: null,
            validationStatus: ValidationStatuses.FAILED,
            interactionCompleted: true,
            errors: [],
          },
        }),
      );
    },
    [dispatch],
  );

  return {
    onFileAttached,
    onFileDetached,
  };
};
